import { CMembershipView } from '../me/home';
import { YPaymentAmount } from '../y/amount';
import { $api } from '../y/api';
import { QRequest, QResponse } from '../y/data-source';
import { $fn } from '../y/fn';
import { $date, $time, YDate } from '../y/time';
import { YCountryId, YDateString, YFlags, YId, YTimeString } from '../y/types';
import { CCityId } from './c-city';
import { CEventAdminView } from './c-event-admin';
import { CUserProducerRole } from './c-producer-admin';
import { CPaidPlanId, CPlanId, CRecurringStatus, CSubscription, CSubscriptionType, CUser } from './c-user';
import { LPermission } from './l-permission';
import { MDelivery } from './m-message';

export interface CUserStatistics {
    revenue: YPaymentAmount;
    ticket_value: YPaymentAmount;
    payout_value: YPaymentAmount;
    bookings_used: number;
    pause_count: number;
    subscribe_count: number;
}

export interface CUserAdminListView {
    id: YId;
    is_test: boolean;
    permissions: YFlags<LPermission>;
    email?: string;
    phone?: string;
    country: YCountryId;
    city_id: CCityId;
    first_name: string;
    last_name: string;
    recurring_status: CRecurringStatus;
    plan: CPlanId;
    payment_date?: YDateString;
    subscription_type?: CSubscriptionType;
    subscription_start?: YDateString;
    subscription_end?: YDateString;
    created_at: YTimeString;
    last_login_at?: YTimeString;
    statistics: CUserStatistics;
    as_user_token: string;
}

export interface PUserPromo {

}

export interface EPaymentAddon {
    code: string;
    name: string;
    usage_max?: number;
    usage_count: number;
    starts_on?: YDateString;
    ends_on?: YDateString;
    amount: { [plan in CPlanId | 'any']?: YPaymentAmount };
}

interface CUserEventTag {

}

interface CUserRecurringChange {

}

export interface CUserAdminView extends CUser {
    subscriptions: CSubscription[];
    promos: PUserPromo[];
    addons: EPaymentAddon[];
    event_tags: CUserEventTag[];
    producer_roles: CUserProducerRole[];
    recurring_changes: CUserRecurringChange[];
}

//TODOURGENT: fix this
export interface CUserSuspiciousView {
    id: YId;
    email: string;
    first_name: string;
    last_name: string;
    phone: string;
    credit_card: string;

    created_at: YTimeString;
    account_status: string;
    score: number;
    duplicates: string[];
}

//TODOURGENT: make response be actually this
export interface CUserCommentsView {
    id: YId;
    city_id: CCityId;
    email: string;
    first_name: string;
    last_name: string;
    notes: string;
    date: YTimeString;
    effective_date: YTimeString;
}

export function cUsersAdminListQuery(params: QRequest) {
    return $api.POST<QResponse<CUserAdminListView>>('c/users/admin_list_view/query', params);
}

export function cUserAdminViewGet(user_id: YId) {
    return $api.GET<CUserAdminView>(`c/user/${user_id}/admin_view`);
}

export function cUserAction(user_id: YId, action: 'add_addon', params: { amount: YPaymentAmount, duration: number, name: string }): Promise<true>;
export function cUserAction(user_id: YId, action: 'add_promo', params: { promo_id: YId }): Promise<true>;
export function cUserAction(user_id: YId, action: 'change_billing_date', params: { date: YDate }): Promise<true>;
export function cUserAction(user_id: YId, action: 'add_free_subscription', params: { plan: CPlanId, months?: number }): Promise<true>;
export function cUserAction(user_id: YId, action: 'force_change_plan', params: { plan: CPaidPlanId }): Promise<true>;
export function cUserAction(user_id: YId, action: 'force_pause', params: { months: number }): Promise<true>;
export function cUserAction(user_id: YId, action: 'force_cancel'): Promise<true>;
export function cUserAction(user_id: YId, action: 'send_password_reset'): Promise<true>;
export function cUserAction(user_id: YId, action: string, data?: any) {
    return $api.POST<CUserAdminView>(`c/user/${user_id}/${action}`, data).then($fn.TRUE);
}

export function cUserGetInfo(user_id: YId, info: 'membership'): Promise<CMembershipView>;
export function cUserGetInfo(user_id: YId, info: 'messages'): Promise<MDelivery[]>;
export function cUserGetInfo(user_id: YId, info: string) {
    return $api.GET<any>(`c/user/${user_id}/${info}`);
}

export function cUserUpdate(user: CUserAdminView, value: any) {
    return $api.PUT<CEventAdminView>(`c/user/${user.id}`, value).then(new_user => {
        Object.assign(user, new_user);
        return user;
    })
}

export function cUserUpdatePassword(user: CUserAdminView, password: string) {
    return $api.PUT(`c/user/${user.id}/password`, { password });
}

export function cUserUpdateProducerRoles(user: CUserAdminView, roles: CUserProducerRole[]) {
    return $api.PUT<CEventAdminView>(`c/user/${user.id}/producer_roles`, { roles }).then(new_user => {
        Object.assign(user, new_user);
        return user;
    });
}

export function cUserUpdatePermissions(user_id: YId, permissions: LPermission[]) {
    return $api.PUT(`c/user/${user_id}/permissions`, { permissions });
}

export function cUserCreate(value: any) {
    return $api.POST<CUserAdminView>(`c/user`, value)
}

export function cUserDelete(user_id: YId) {
    return $api.DELETE(`c/user/${user_id}`);
}

export function cUserCalcLoyalty(user: CUserAdminListView) {
    if(!user.subscription_start)
        return 0;
    return $date.today().sub($date(user.subscription_start), $time.day);
}

let users_suspicious_view_promise: Promise<CUserSuspiciousView[]> | undefined;

export function cUsersSuspiciousView(reload?: boolean) {
    if(!users_suspicious_view_promise || reload) {
        users_suspicious_view_promise = $api.GET<CUserSuspiciousView[]>('c/users/suspicious_view');
    }

    return users_suspicious_view_promise;
}

let users_comments_view_promise: Promise<CUserCommentsView[]> | undefined;

export function cUsersCommentsView(reload?: boolean) {
    if(!users_comments_view_promise || reload) {
        users_comments_view_promise = $api.GET<CUserCommentsView[]>('c/users/comments_view');
    }

    return users_comments_view_promise;
}
